// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"6beb2afc","125":"f10c2311","369":"2a665b2c","498":"b54e9044","513":"604e1501","703":"4974703c","787":"af50305a"}[chunkId] + ".chunk.js";
};